<div class="shareholder-steps">
    <div class="shareholder-steps-item">
        <!-- Removida linha à esquerda do primeiro step -->
        <!-- Linha que sai da Edição: completa se passou da edição OU se está rejeitado (para conectar até o rejeitado) -->
        <div class="shareholder-steps-item-line half"
            [class.complete]="shouldCompleteLineFromEdit()">
        </div>

        <div class="shareholder-steps-item-indicator"
            [class.half]="!isRejected() && (approval?.step || 0) == 0 && !isHomologated()"
            [class.complete]="isRejected() || (approval?.step || 0) > 0 || approval?.completed || isHomologated()">
        </div>
        <app-spacer [bottom]="12"></app-spacer>

        <span class="shareholder-steps-item-department">Edição</span>
        <app-spacer [bottom]="5"></app-spacer>

    </div>

    <ng-container *ngIf="hasRepresentativeSignStep()">
        <div class="shareholder-steps-item">
            <!-- Linha à esquerda: completa se concluiu assinatura ou se rejeitado -->
            <div class="shareholder-steps-item-line"
                [class.complete]="shouldCompleteLineFromEdit()">
            </div>
            <!-- Linha à direita: completa se assinaturas concluídas -->
            <div class="shareholder-steps-item-line half"
                [class.complete]="isRepresentativeSignComplete() || approval?.completed || isHomologated()">
            </div>

            <div class="shareholder-steps-item-indicator"
                [class.complete]="isRepresentativeSignComplete() || approval?.completed || isHomologated()"
                [class.half]="!isRejected() && !isRepresentativeSignComplete()">
            </div>
            <app-spacer [bottom]="12"></app-spacer>

            <span
                class="shareholder-steps-item-department">Representantes</span>
            <app-spacer [bottom]="5"></app-spacer>
            <span class="shareholder-steps-item-date">
                {{getRepresentativeSignStatus()?.signed}}/{{getRepresentativeSignStatus()?.total}}
            </span>
        </div>
    </ng-container>

    <ng-container *ngIf="approval.queue?.departments?.length > 0">
        <div class="shareholder-steps-item"
            *ngFor="let department of approval.queue.departments; let i = index">
            <!-- Linha à esquerda: completa se chegou até este departamento (incluindo se foi rejeitado nele) -->
            <div class="shareholder-steps-item-line"
                [class.complete]="shouldCompleteLineToDepartment(department, i)">
            </div>
            <!-- Linha à direita: completa apenas se o departamento foi completado E não foi rejeitado -->
            <div class="shareholder-steps-item-line half"
                [class.complete]="shouldCompleteLineFromDepartment(department)">
            </div>

            <div class="shareholder-steps-item-indicator"
                [class.complete]="getDepartmentCompleted(department) || isHomologated()"
                [class.half]="!isRejected() && isCurrentDepartment(department, i) && !isHomologated()">
            </div>
            <app-spacer [bottom]="12"></app-spacer>

            <span class="shareholder-steps-item-department">{{department.type
                === 'department' ?
                (department.department?.name || '') :
                getAgentName(department.agent)}}</span>
            <app-spacer [bottom]="5"></app-spacer>

            <!-- Exibir informações de approved_by, rejected_by ou returned_by se existirem -->
            <ng-container
                *ngIf="isDepartmentApprovedBy(department) && getApprovedBy()">
                <span class="shareholder-steps-item-date">
                    Aprovado por {{getActionUserName(getApprovedBy())}}
                    <span *ngIf="getActionDepartmentName(getApprovedBy())"> -
                        {{getActionDepartmentName(getApprovedBy())}}</span>
                    <span *ngIf="getActionAgentName(getApprovedBy())">
                        ({{getActionAgentName(getApprovedBy())}})</span>
                    <br> em {{formatActionDate(getApprovedBy())}}
                </span>
            </ng-container>

            <ng-container
                *ngIf="isDepartmentRejectedBy(department) && getRejectedBy()">
                <span class="shareholder-steps-item-date">
                    Rejeitado por {{getActionUserName(getRejectedBy())}}
                    <span *ngIf="getActionDepartmentName(getRejectedBy())"> -
                        {{getActionDepartmentName(getRejectedBy())}}</span>
                    <span *ngIf="getActionAgentName(getRejectedBy())">
                        ({{getActionAgentName(getRejectedBy())}})</span>
                    <br> em {{formatActionDate(getRejectedBy())}}
                </span>
            </ng-container>

            <ng-container
                *ngIf="isDepartmentReturnedBy(department) && getReturnedBy()">
                <span class="shareholder-steps-item-date">
                    Retornado por {{getActionUserName(getReturnedBy())}}
                    <span *ngIf="getActionDepartmentName(getReturnedBy())"> -
                        {{getActionDepartmentName(getReturnedBy())}}</span>
                    <span *ngIf="getActionAgentName(getReturnedBy())">
                        ({{getActionAgentName(getReturnedBy())}})</span>
                    <br> em {{formatActionDate(getReturnedBy())}}
                </span>
            </ng-container>

            <!-- Fallback para signatures se não houver approved_by/rejected_by/returned_by -->
            <ng-container
                *ngIf="!isDepartmentApprovedBy(department) && !isDepartmentRejectedBy(department) && !isDepartmentReturnedBy(department)">
                <ng-container *ngIf="getDepartmentSigns(department).length > 0">
                    <span class="shareholder-steps-item-date"
                        *ngFor="let eachApproval of getDepartmentSigns(department); let i = index">
                        <ng-container *ngIf="eachApproval?.approved">
                            Aprovado por
                            {{getRegisterName(eachApproval?.register)}}
                        </ng-container>
                        <ng-container
                            *ngIf="!eachApproval?.approved && eachApproval?.restart">
                            Retornado por
                            {{getRegisterName(eachApproval?.register)}}
                        </ng-container>
                        <ng-container
                            *ngIf="!eachApproval?.approved && !eachApproval?.restart">
                            Rejeitado por
                            {{getRegisterName(eachApproval?.register)}}
                        </ng-container>
                        <br> em {{formatDateTime(eachApproval?.date)}}
                    </span>
                </ng-container>
            </ng-container>

            <span class="shareholder-steps-item-date"
                *ngIf="!getDepartmentCompleted(department) && !isDepartmentApprovedBy(department) && !isDepartmentRejectedBy(department) && !isDepartmentReturnedBy(department)">
                Aguardando aprovação
            </span>
        </div>
    </ng-container>

    <!-- Step "Homologado" - aparece após todas as aprovações -->
    <div class="shareholder-steps-item"
        *ngIf="approval.queue?.departments?.length > 0">
        <!-- Linha à esquerda conectando com o último departamento -->
        <div class="shareholder-steps-item-line"
            [class.complete]="!isRejected() && (allDepartmentsCompleted() || isHomologated())">
        </div>
        <!-- Sem linha à direita pois é o último step -->

        <div class="shareholder-steps-item-indicator"
            [class.complete]="!isRejected() && isHomologated()"
            [class.half]="!isRejected() && allDepartmentsCompleted() && !isHomologated()">
        </div>
        <app-spacer [bottom]="12"></app-spacer>

        <span class="shareholder-steps-item-department">
            Homologado
            <ng-container *ngIf="getHomologationReason()">
                <app-tooltip [text]="getHomologationReason()" position="top">
                    <svg-icon src="assets/images/icon-info.svg"
                        class="shareholder-steps-item-tooltip-trigger"
                        aria-label="Justificativa"></svg-icon>
                </app-tooltip>
            </ng-container>
        </span>
        <app-spacer [bottom]="5"></app-spacer>

        <!-- Exibir informações de homologação se existirem -->
        <ng-container *ngIf="getHomologatedBy()">
            <span class="shareholder-steps-item-date">
                Homologado por {{getActionUserName(getHomologatedBy())}}
                <span *ngIf="getActionDepartmentName(getHomologatedBy())"> -
                    {{getActionDepartmentName(getHomologatedBy())}}</span>
                <span *ngIf="getActionAgentName(getHomologatedBy())">
                    ({{getActionAgentName(getHomologatedBy())}})</span>
                <br> em {{formatActionDate(getHomologatedBy())}}
            </span>
        </ng-container>
    </div>
</div>